<template>
    <FormControl
        required
        label="Name"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_Automation_Update_Name,
            )
        "
    >
        <TextInput
            :name="RequestBodyKeyEnum.App_Automation_Update_Name"
            :value="automation.name"
            required
        />
    </FormControl>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'
    import Automation from '@/App/Automation/Entity/Automation'

    const props = defineProps({
        automation: {
            type: Object as PropType<Automation>,
            required: true,
        },
        errors: {
            type: [Object, null] as PropType<ApiFormErrors | null>,
            required: true,
        },
    })
</script>
